import React from 'react';
import { Row, Col } from "react-bootstrap";
import PropTypes from 'prop-types';
import { Button, SvgIcon as MuiSvgIcon } from '@mui/material';
import { CheckCircle as CheckCircleIcon } from '@mui/icons-material';
import { useController, useForm, useFormContext } from 'react-hook-form';
import CheckCircleWhite from '../../../icons/check-circle-white.svg?react';
import SvgIcon from '../Svg/SvgIcon';
import './StyledRadioInput.scss';

function FancyButton(props) {

  const buttonClasses = `styled-button ${(props.active ? "styled-button-active" : "styled-button-inactive")} ${(props.error ? "styled-button-error" : '')} ${props.isWhiteBackground ? "white-background" : ''}`;

  const blankIcon = props.isBlankIcon ? <MuiSvgIcon component={CheckCircleWhite} className="margin-left-class" /> : <CheckCircleIcon className="margin-left-class" htmlColor='#bbb' />;

  return (
    <Button id="radio-input" className={buttonClasses} variant="outlined" color="primary" fullWidth onClick={props.onClick} aria-describedby="radio-input" aria-invalid="true">
      {props.icon && <div className={`styled-icon margin-right-class`}><SvgIcon iconName={props.icon} className="svg-icon" /></div>}
      <div className={props.active ? "styled-label-selected" : "styled-label"}>{props.label}</div>
      {!props.isBlankCheckMark && <div className="styled-check"> {props.active ? <CheckCircleIcon className="margin-left-class" color="primary" /> : blankIcon} </div>}
    </Button>
  )
}

export default function StyledRadioInput(props) {
  const formContext = useFormContext();
  const fallbackForm = useForm();
  const { control } = formContext ?? fallbackForm; // Fallback if used outside FormProvider
  const {
    field,
    fieldState: { error },
  } = useController({
    name: props.name,
    control
  });

  const handleChange = (value) => {
    field.onChange(value)
    props.onChange && props.onChange(value)
  }
  return (
    <div>
      {props.label && <legend className="styled-label-legend">{props.label}</legend>}
      <Row className='radio-input'>
        <Col xs={6} className="ppe-6">
          <div className="form-group mb-3">
            <FancyButton
              active={field.value === props.options[0].value}
              icon={props.options[0].icon}
              label={props.options[0].label}
              onClick={() => handleChange(props.options[0].value)}
              error={!!error}
              isBlankIcon={props.isBlankIcon}
              isBlankCheckMark={props.isBlankCheckMark}
              isWhiteBackground={props.isWhiteBackground}
              id={props.id}
            />
          </div>
        </Col>
        <Col xs={6} className="pps-6">
          <div className="form-group mb-3">
            <FancyButton
              active={field.value === props.options[1].value}
              icon={props.options[1].icon}
              label={props.options[1].label}
              onClick={() => handleChange(props.options[1].value)}
              error={!!error}
              isBlankIcon={props.isBlankIcon}
              isBlankCheckMark={props.isBlankCheckMark}
              isWhiteBackground={props.isWhiteBackground}
            />
          </div>
        </Col>
        {error && <span className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error d-block px-0">{error.message}</span>}
      </Row>
    </div>
  )
}

StyledRadioInput.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.any,
  isBlankIcon: PropTypes.bool,
  isBlankCheckMark: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    icon: PropTypes.string,
  })),
}